module.exports = __webpack_public_path__ + "static/media/withdraw-small-icon.cb3263bf.svg";